import * as z from 'zod';

export const nocTypeFormSchema = z.object({
  Name: z.string().trim().min(1, { message: 'NAME_REQUIRED' }),
  DocumentBody: z.string().trim().min(1, { message: 'NOC_BODY_REQUIRED' }),
});

export type NocTypeFormValues = z.infer<typeof nocTypeFormSchema>;
